import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-[#0E223B] text-white font-semibold gap-2 py-8 text-center text-sm">
            <div className=" max-w-7xl mx-auto px-4">
                {/* Navigation Links */}
                <div className="flex flex-wrap justify-center space-x-4 mb-4">
                    <a href="#" className="hover:text-gray-300">Contact</a>
                    <a href="#" className="hover:text-gray-300">Terms</a>
                    <a href="#" className="hover:text-gray-300">Privacy</a>
                    <a href="#" className="hover:text-gray-300">Return Policy</a>
                    <a href="#" className="hover:text-gray-300">Shipping</a>
                    <a href="#" className="hover:text-gray-300">Disclaimer</a>
                    <a href="#" className="hover:text-gray-300">References</a>
                </div>

                {/* Disclaimers */}
                <p className="text-gray-400 text-sm mb-4">
                    Statements on this website have not been evaluated by the Food and Drug Administration. Products are not intended to diagnose, treat, cure or prevent any disease.
                </p>
                <p className="text-gray-400 text-sm mb-4">
                    The website's content and the product for sale is based upon the author's opinion and is provided solely on an "AS IS" and "AS AVAILABLE" basis. You should do your own research and
                    confirm the information with other sources when searching for information regarding health issues and always review the information carefully with your professional health care provider
                    before using any of the protocols presented on this website and/or in the product sold here. Neither BuyGoods nor the author are engaged in rendering medical or similar professional services
                    or advice via this website or in the product, and the information provided is not intended to replace medical advice offered by a physician or other licensed healthcare provider. You should not
                    construe BuyGoods's sale of this product as an endorsement by BuyGoods of the views expressed herein, or any warranty or guarantee of any strategy, recommendation, treatment, action, or
                    application of advice made by the author of the product.
                </p>
                <p className="text-gray-400 text-sm mb-4">
                    Some names and personal identifying information on this site have been changed to protect the privacy of individuals.
                </p>

                {/* Copyright */}
                <p className="text-gray-400 text-sm">
                    &copy; {new Date().getFullYear()} Lung Renew.net. All Rights Reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
